import useBrandImageResolver from '@/components/useBrandImageResolver'

import useCurrentUserLocation from '@/lib/useCurrentUserLocation'
import type { Language } from '@/types'

const brand = import.meta.env.PUBLIC_APP_BRAND

const createBrandImage = () => {
  const img = document.createElement('img')

  const src = useBrandImageResolver(brand, 'icons/Location.svg')

  img.src = src
  img.className = 'h-full w-full'

  return img
}

export const createPositionControl = (
  map: google.maps.Map,
  message: string,
  lang: Language,
) => {
  const controlButton = document.createElement('button')
  controlButton.className =
    'bg-white p-1 w-8 h-8 flex items-center justify-center cursor-pointer rounded-md mr-4 hidden xs:block'

  const brandImage = createBrandImage()
  controlButton.appendChild(brandImage)

  controlButton.addEventListener('click', () =>
    useCurrentUserLocation(map, message, lang),
  )

  const createControlDiv = document
    .createElement('div')
    .appendChild(controlButton)

  return createControlDiv
}
